// assets/collection-infinite-scroll.js
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    try {
      console.log('[infinite] init');

      const section = document.querySelector('[data-section-type="collection"]');
      if (!section) {
        console.log('[infinite] no collection section found');
        return;
      }

      const isEnabled = (section.getAttribute('data-infinite-scroll') === 'true') || (section.dataset.infiniteScroll === 'true');
      if (!isEnabled) {
        console.log('[infinite] infinite scroll disabled on this section');
        return;
      }

      const grid = section.querySelector('#CollectionLoop');
      if (!grid) {
        console.log('[infinite] #CollectionLoop not found');
        return;
      }

      // find pagination node(s) - used for replacements, not detection only
      const paginationWrapper = section.querySelector('.pagination-wrapper') || section.querySelector('.pagination-custom') || section.querySelector('.pagination');

      // helper: find 'next' URL inside a document - FIXED VERSION
      function getNextUrl(containerDoc) {
        if (!containerDoc) return null;
        
        // First, try to find explicit "next" links
        const nextSelectors = [
          '.pagination-custom__next[href]',
          'a[rel="next"][href]',
          '.next[href]',
          '.pagination__next[href]'
        ];
        
        for (let s of nextSelectors) {
          const el = containerDoc.querySelector(s);
          if (el && el.href) {
            console.log('[infinite] found next URL via selector:', s, el.href);
            return el.href;
          }
        }
        
        // If no explicit next link, look for pagination that indicates current page
        const paginationLinks = containerDoc.querySelectorAll('.pagination a[href*="page="], .pagination-custom a[href*="page="]');
        const currentPageItem = containerDoc.querySelector('.pagination .is-current, .pagination-custom .is-current, .pagination .active, .pagination-custom .active');
        
        if (currentPageItem && paginationLinks.length > 0) {
          let currentPageNum = 1;
          const currentText = currentPageItem.textContent.trim();
          const currentMatch = currentText.match(/(\d+)/);
          if (currentMatch) {
            currentPageNum = parseInt(currentMatch[1]);
          }
          
          // Find the next page link
          const nextPageNum = currentPageNum + 1;
          for (let link of paginationLinks) {
            const href = link.href;
            const pageMatch = href.match(/[?&]page=(\d+)/) || href.match(/\/page\/(\d+)/);
            if (pageMatch) {
              const pageNum = parseInt(pageMatch[1]);
              if (pageNum === nextPageNum) {
                console.log('[infinite] found next URL via page number:', nextPageNum, href);
                return href;
              }
            }
          }
        }
        
        // Last resort: try to increment current page from URL
        const currentUrl = window.location.href;
        const urlPageMatch = currentUrl.match(/[?&]page=(\d+)/) || currentUrl.match(/\/page\/(\d+)/);
        if (urlPageMatch) {
          const currentPage = parseInt(urlPageMatch[1]);
          const nextPage = currentPage + 1;
          const nextUrl = currentUrl.replace(/([?&]page=)\d+/, `$1${nextPage}`).replace(/\/page\/\d+/, `/page/${nextPage}`);
          console.log('[infinite] computed next URL from current URL:', nextUrl);
          return nextUrl;
        } else {
          // First page, no page parameter
          const separator = currentUrl.includes('?') ? '&' : '?';
          const nextUrl = currentUrl + separator + 'page=2';
          console.log('[infinite] computed first next URL:', nextUrl);
          return nextUrl;
        }
      }

      // debug initial next url
      const initialNext = getNextUrl(document);
      console.log('[infinite] initial next url:', initialNext);

      // parse HTML helper
      function parseHTML(text) {
        try {
          return new DOMParser().parseFromString(text, 'text/html');
        } catch (e) {
          console.error('[infinite] parseHTML failed', e);
          return null;
        }
      }

      // append children from fetched #CollectionLoop
      function appendProductsFromDoc(remoteDoc) {
        const remoteGrid = remoteDoc && remoteDoc.querySelector('#CollectionLoop');
        if (!remoteGrid) {
          console.log('[infinite] remote #CollectionLoop not found');
          return 0;
        }
        const newNodes = Array.from(remoteGrid.children);
        newNodes.forEach(node => {
          const imported = document.importNode(node, true);
          grid.appendChild(imported);
        });
        return newNodes.length;
      }

      // update pagination markup (replace remote pagination-custom or .pagination)
      function updatePagination(remoteDoc) {
        if (!remoteDoc) return;
        const remoteCustom = remoteDoc.querySelector('.pagination-custom');
        if (remoteCustom) {
          const existing = section.querySelector('.pagination-custom');
          if (existing) {
            existing.outerHTML = remoteCustom.outerHTML;
            console.log('[infinite] replaced .pagination-custom markup');
            return;
          }
          const wrapper = section.querySelector('.pagination-wrapper');
          if (wrapper) {
            wrapper.innerHTML = remoteCustom.outerHTML;
            console.log('[infinite] updated .pagination-wrapper with remote .pagination-custom');
            return;
          }
        }

        const remotePag = remoteDoc.querySelector('.pagination') || remoteDoc.querySelector('.pagination-wrapper');
        if (remotePag) {
          const existingPag = section.querySelector('.pagination') || section.querySelector('.pagination-wrapper');
          if (existingPag) {
            // if existingPag is the wrapper, replace innerHTML, otherwise replace node
            if (existingPag.classList.contains('pagination-wrapper')) {
              existingPag.innerHTML = remotePag.innerHTML;
              console.log('[infinite] updated .pagination-wrapper innerHTML');
            } else {
              existingPag.outerHTML = remotePag.outerHTML;
              console.log('[infinite] replaced .pagination markup');
            }
            return;
          }
        }

        // remote had no pagination — remove local
        const anyExisting = section.querySelector('.pagination-custom, .pagination, .pagination-wrapper');
        if (anyExisting) {
          anyExisting.remove();
          console.log('[infinite] removed local pagination (no remote pagination found)');
        }
      }

      let isLoading = false;
      let currentPage = 1;

      async function loadNextPage(nextUrl) {
        if (isLoading) return;
        if (!nextUrl) {
          console.log('[infinite] no nextUrl to load');
          if (observer) observer.disconnect();
          return;
        }

        // Check if we're going backwards (loop detection)
        const nextPageMatch = nextUrl.match(/[?&]page=(\d+)/) || nextUrl.match(/\/page\/(\d+)/);
        if (nextPageMatch) {
          const nextPageNum = parseInt(nextPageMatch[1]);
          if (nextPageNum <= currentPage) {
            console.log('[infinite] detected pagination loop, stopping. current:', currentPage, 'next:', nextPageNum);
            if (observer) observer.disconnect();
            return;
          }
          currentPage = nextPageNum;
        }

        isLoading = true;
        sentinel.classList.add('is-loading');
        console.log('[infinite] fetching', nextUrl);

        try {
          const resp = await fetch(nextUrl, { credentials: 'same-origin' });
          if (!resp.ok) throw new Error('Network response not ok: ' + resp.status);
          const text = await resp.text();
          const remoteDoc = parseHTML(text);
          if (!remoteDoc) throw new Error('Failed to parse remote HTML');

          const appended = appendProductsFromDoc(remoteDoc);
          console.log('[infinite] appended nodes:', appended);

          updatePagination(remoteDoc);

          // notify others
          document.dispatchEvent(new CustomEvent('collection:infinite:loaded', { detail: { appended } }));

          const newNext = getNextUrl(document);
          console.log('[infinite] next url after update:', newNext);
          
          // Additional loop detection
          if (newNext && newNext === nextUrl) {
            console.log('[infinite] next URL is same as current, stopping to prevent loop');
            if (observer) observer.disconnect();
            return;
          }
          
          if (!newNext && observer) {
            observer.disconnect();
            console.log('[infinite] finished (no more pages)');
          }
        } catch (err) {
          console.error('[infinite] error loading next page', err);
          if (observer) observer.disconnect();
        } finally {
          isLoading = false;
          sentinel.classList.remove('is-loading');
        }
      }

      // ALWAYS use a sentinel element so the IntersectionObserver has a visible target
      const sentinel = document.createElement('div');
      sentinel.className = 'collection-infinite-sentinel';
      // small inline styles so it's visible for the observer even if hidden by CSS elsewhere
      sentinel.style.minHeight = '1px';
      sentinel.style.width = '100%';
      grid.parentNode.appendChild(sentinel);
      console.log('[infinite] sentinel appended');

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !isLoading) {
            // compute nextUrl at moment of intersection to be robust to filter changes
            const url = getNextUrl(document);
            console.log('[infinite] sentinel intersecting, nextUrl =', url);
            if (url) loadNextPage(url);
            else {
              console.log('[infinite] no next url available when sentinel intersected');
              observer.disconnect();
            }
          }
        });
      }, {
        root: null,
        rootMargin: '400px',
        threshold: 0
      });

      observer.observe(sentinel);
      console.log('[infinite] observer started');
    } catch (e) {
      console.error('[infinite] init failed', e);
    }
  });
})();